import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import commonStyles from '../common.module.css';
import Customer from '../../../models/Customer';
import styles from './BasicInformation.module.css';
import { getCountryByValue } from '../../common/CountrySelect/countries';

type BasicInformationProps = {
  customer: Customer;
};

function BasicInformationView(props: BasicInformationProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className={commonStyles.row}>
        <div className={styles.field}>
          <div className={styles.label}>{t('customer.dashboard.basicInformation.label.name')}</div>
          <div>
            {props.customer.firstName} {props.customer.name}
          </div>
        </div>
        <div className={styles.field}>
          <div className={styles.label}>
            {props.customer.personType === 'PRIVATE'
              ? t('customer.dashboard.basicInformation.label.personalId')
              : t('customer.dashboard.basicInformation.label.registryCode')}
          </div>
          <div>{props.customer.registrationCode}</div>
        </div>
        <div className={styles.field}>
          <div className={styles.label}>
            {props.customer.personType === 'PRIVATE'
              ? t('customer.dashboard.basicInformation.label.citizenship')
              : t('customer.dashboard.basicInformation.label.countryOfIncorporation')}
          </div>
          <div>{getCountryByValue(props.customer.country)}</div>
        </div>
        <div className={styles.field}>
          <div className={styles.label}>
            {t('customer.dashboard.basicInformation.label.language')}
          </div>
          <div>{props.customer.preferredLanguage}</div>
        </div>
      </div>
      <div className={commonStyles.row}>
        <div className={styles.field}>
          <div className={styles.label}>{t('customer.dashboard.basicInformation.label.cif')}</div>
          <div>{props.customer.cif}</div>
        </div>
        {props.customer.personType === 'PRIVATE' && (
          <div className={styles.field}>
            <div className={styles.label}>
              {t('customer.dashboard.basicInformation.label.ssLogin')}
            </div>
            <div>{props.customer.loginName}</div>
          </div>
        )}
        <div className={styles.field}>
          <div className={styles.label}>
            {t('customer.dashboard.basicInformation.label.status')}
          </div>
          <div>{props.customer.customerStatus}</div>
        </div>
        <div
          className={classNames(
            styles.field,
            props.customer.personType === 'LEGAL' && styles.longField,
          )}
        >
          <div className={styles.label}>
            {t('customer.dashboard.basicInformation.label.activity.title')}
          </div>
          <div
            className={classNames(
              styles.activityContainer,
              props.customer.active ? styles.active : styles.inactive,
            )}
          />
          <div>
            {props.customer.active
              ? t('customer.dashboard.basicInformation.label.activity.active')
              : t('customer.dashboard.basicInformation.label.activity.inactive')}
          </div>
        </div>
      </div>
      <div className={commonStyles.row}>
        <div className={styles.field}>
          <div className={styles.label}>{t('customer.dashboard.basicInformation.label.email')}</div>
          <div>{props.customer.email}</div>
        </div>
        <div className={styles.field}>
          <div className={styles.label}>{t('customer.dashboard.basicInformation.label.phone')}</div>
          <div>{props.customer.phone}</div>
        </div>
        <div className={classNames(styles.field, styles.longField)}>
          <div className={styles.label}>
            {t('customer.dashboard.basicInformation.label.everisePortfolioId')}
          </div>
          {props.customer.portfolios
            ?.sort((a, b) => a.id! - b.id!)
            .map((portfolio, index) => (
              <span key={portfolio.id}>
                {portfolio.everisePortfolioId}
                {props.customer.portfolios?.length && index !== props.customer.portfolios.length - 1
                  ? ', '
                  : ''}
              </span>
            ))}
        </div>
      </div>
      <div className={styles.comments}>
        <div className={styles.label}>
          {t('customer.dashboard.basicInformation.label.comments')}
        </div>
        <div>{props.customer.comments}</div>
      </div>
    </>
  );
}

export default BasicInformationView;
